import Vue from 'vue'
import VueRouter from 'vue-router'
import auth from './auth'
import store from '@/store'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    auth,
    {
      path: '/',
      name: 'home',
      redirect: { name: 'newsletter' },
      component: () => import(/* webpackChunkName: "home" */ '@/views/Home'),
      children: [
        {
          path: 'inbox',
          name: 'inbox',
          meta: {
            roles: ['ADMIN']
          },
          component: () =>
            import(/* webpackChunkName: "inbox" */ '@/views/Home/Inbox')
        },
        {
          path: 'publishers',
          name: 'publishers',
          meta: {
            roles: ['ADMIN']
          },
          component: () =>
            import(/* webpackChunkName: "publishers" */ '@/views/Home/Publishers')
        },
        {
          path: 'publishers/create',
          name: 'publisher.create',
          meta: {
            roles: ['ADMIN']
          },
          component: () =>
            import(/* webpackChunkName: "publisher-details" */ '@/views/Home/Publishers/PublisherCreate')
        },
        {
          path: 'publishers/:id',
          name: 'publisher.details',
          meta: {
            roles: ['ADMIN']
          },
          component: () =>
            import(/* webpackChunkName: "publisher-details" */ '@/views/Home/Publishers/PublisherDetails')
        },
        {
          path: 'editors',
          name: 'editors',
          meta: {
            roles: ['ADMIN']
          },
          component: () =>
            import(/* webpackChunkName: "editors" */ '@/views/Home/Editors')
        },
        {
          path: 'editors/create',
          name: 'editor.create',
          meta: {
            roles: ['ADMIN']
          },
          component: () =>
            import(/* webpackChunkName: "editor-details" */ '@/views/Home/Editors/EditorCreate')
        },
        {
          path: 'editors/:id',
          name: 'editor.details',
          meta: {
            roles: ['ADMIN']
          },
          component: () =>
            import(/* webpackChunkName: "editor-details" */ '@/views/Home/Editors/EditorDetails')
        },
        {
          path: 'users',
          name: 'users',
          meta: {
            roles: ['ADMIN']
          },
          component: () =>
            import(/* webpackChunkName: "users" */ '@/views/Home/Users')
        },
        {
          path: 'users/:id',
          name: 'user.details',
          meta: {
            roles: ['ADMIN']
          },
          component: () =>
            import(/* webpackChunkName: "user-details" */ '@/views/Home/Users/UserDetails')
        },
        {
          path: 'user-guides',
          name: 'user-guides',
          meta: {
            roles: ['ADMIN', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "user-guides" */ '@/views/Home/UserGuides')
        },
        {
          path: 'user-guides/create',
          name: 'user-guides.create',
          meta: {
            roles: ['ADMIN', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "user-guides.create" */ '@/views/Home/UserGuides/create')
        },
        {
          path: 'user-guides/:id/edit',
          name: 'user-guides.edit',
          meta: {
            roles: ['ADMIN', 'PUBLISHER', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "user-guides" */ '@/views/Home/UserGuides/edit')
        },
        {
          path: 'onboarding',
          name: 'onboarding',
          meta: {
            roles: ['ADMIN']
          },
          component: () =>
            import(/* webpackChunkName: "user-guides" */ '@/views/Home/Onboarding')
        },
        {
          path: 'teams-and-players',
          name: 'teams-and-players',
          meta: {
            roles: ['ADMIN', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "teams-and-players" */ '@/views/Home/TeamsAndPlayers')
        },
        {
          path: 'teams-and-players/create',
          name: 'teams-and-players.create',
          meta: {
            roles: ['ADMIN', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "teams-and-players" */ '@/views/Home/TeamsAndPlayers/create')
        },
        {
          path: 'teams-and-players/:id/edit',
          name: 'teams-and-players.edit',
          meta: {
            roles: ['ADMIN', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "teams-and-players" */ '@/views/Home/TeamsAndPlayers/edit')
        },
        {
          path: 'sports-betting',
          name: 'sports-betting',
          meta: {
            roles: ['ADMIN', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "sport-betting" */ '@/views/Home/SportsBetting')
        },
        {
          path: 'sports-betting/create',
          name: 'sports-betting.create',
          meta: {
            roles: ['ADMIN', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "sport-betting" */ '@/views/Home/SportsBetting/create')
        },
        {
          path: 'sports-betting/:id/edit',
          name: 'sports-betting.edit',
          meta: {
            roles: ['ADMIN', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "sport-betting" */ '@/views/Home/SportsBetting/edit')
        },
        {
          path: 'newsletter',
          name: 'newsletter',
          meta: {
            roles: ['ADMIN']
          },
          component: () =>
            import(/* webpackChunkName: "early-access" */ '@/views/Home/EarlyAccessRequests')
        },
        {
          path: 'articles',
          name: 'articles',
          meta: {
            roles: ['ADMIN', 'PUBLISHER', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "articles" */ '@/views/Home/Articles')
        },
        {
          path: 'articles/create',
          name: 'articles.create',
          meta: {
            roles: ['ADMIN', 'PUBLISHER', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "articles" */ '@/views/Home/Articles/CreateArticle')
        },
        {
          path: 'articles/:id/edit',
          name: 'articles.edit',
          meta: {
            roles: ['ADMIN', 'PUBLISHER', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "articles" */ '@/views/Home/Articles/EditArticle')
        },
        {
          path: 'sportsbooks',
          name: 'sportsbooks',
          meta: {
            roles: ['ADMIN', 'PUBLISHER', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "sportsbooks" */ '@/views/Home/SportsBooks')
        },

        {
          path: 'sportsbooks2',
          name: 'sportsbooks.list',
          meta: {
            roles: ['ADMIN', 'PUBLISHER', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "sportsbooks" */ '@/views/Home/SportsBooks2')
        },

        {
          path: 'sportsbooks/:id/edit',
          name: 'sportsbooks.edit',
          meta: {
            roles: ['ADMIN', 'PUBLISHER', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "sportsbooks" */ '@/views/Home/SportsBooks2/EditSportsBook')
        },

        {
          path: 'sportsbooks/create',
          name: 'sportsbooks.create',
          meta: {
            roles: ['ADMIN', 'PUBLISHER', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "sportsbooks" */ '@/views/Home/SportsBooks2/CreateSportsBook')
        },
        {
          path: 'sportsbooks-best-promo',
          name: 'sportsbooks.best-promo',
          meta: {
            roles: ['ADMIN', 'PUBLISHER', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "sportsbooks" */ '@/views/Home/SportsBooks/BestPromo')
        },
        {
          path: 'sportsbooks-welcome-promo',
          name: 'sportsbooks.welcome-promo',
          meta: {
            roles: ['ADMIN', 'PUBLISHER', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "sportsbooks" */ '@/views/Home/SportsBooks/WelcomePromo')
        },
        {
          path: 'sportsbooks-promo',
          name: 'sportsbooks.promo',
          meta: {
            roles: ['ADMIN', 'PUBLISHER', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "sportsbooks" */ '@/views/Home/SportsBooks/Promo')
        },
        {
          path: 'tags',
          name: 'tags',
          meta: {
            roles: ['ADMIN', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "tags" */ '@/views/Home/Tags')
        },
        {
          path: 'tags/create',
          name: 'tags.create',
          meta: {
            roles: ['ADMIN', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "tags" */ '@/views/Home/Tags/TagCreate')
        },
        {
          path: 'tags/:id',
          name: 'tags.details',
          meta: {
            roles: ['ADMIN', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "tags" */ '@/views/Home/Tags/TagDetails')
        },
        {
          path: 'associated-press',
          name: 'associated-press',
          meta: {
            roles: ['ADMIN', 'PUBLISHER', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "articles" */ '@/views/Home/AssociatedPress')
        },
        {
          path: 'associated-press/:id/create-article',
          name: 'associated-press.create-article',
          meta: {
            roles: ['ADMIN', 'PUBLISHER', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "articles" */ '@/views/Home/AssociatedPress/CreateArticle')
        },
        {
          path: 'page-settings',
          name: 'page-settings',
          meta: {
            roles: ['ADMIN', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "page-settings" */ '@/views/Home/PageSettings')
        },
        {
          path: 'page-settings/create',
          name: 'page-settings.create',
          meta: {
            roles: ['ADMIN', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "page-settings" */ '@/views/Home/PageSettings/create')
        },
        {
          path: 'page-settings/:id/edit',
          name: 'page-settings.edit',
          meta: {
            roles: ['ADMIN', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "page-settings" */ '@/views/Home/PageSettings/edit')
        },
        {
          path: 'app-settings',
          name: 'app-settings',
          meta: {
            roles: ['ADMIN', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "app-settings" */ '@/views/Home/AppSettings')
        },
        {
          path: 'bethub-pages',
          name: 'bethub-pages',
          meta: {
            roles: ['ADMIN', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "bethub-pages" */ '@/views/Home/BetHubPages')
        },
        {
          path: 'bethub-pages/create',
          name: 'bethub-pages.create',
          meta: {
            roles: ['ADMIN', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "bethub-pages" */ '@/views/Home/BetHubPages/create')
        },
        {
          path: 'bethub-pages/:id/edit',
          name: 'bethub-pages.edit',
          meta: {
            roles: ['ADMIN', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "bethub-pages" */ '@/views/Home/BetHubPages/edit')
        },
        {
          path: 'bethub-seo-templates',
          name: 'bethub-seo-templates',
          meta: {
            roles: ['ADMIN', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "bethub-seo-templates" */ '@/views/Home/BetHubSeoTemplates')
        },
        {
          path: 'bethub-seo-templates/create',
          name: 'bethub-seo-templates.create',
          meta: {
            roles: ['ADMIN', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "bethub-seo-templates" */ '@/views/Home/BetHubSeoTemplates/create')
        },
        {
          path: 'bethub-seo-templates/:id/edit',
          name: 'bethub-seo-templates.edit',
          meta: {
            roles: ['ADMIN', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "bethub-seo-templates" */ '@/views/Home/BetHubSeoTemplates/edit')
        },
        {
          path: 'app-redirects',
          name: 'app-redirects',
          meta: {
            roles: ['ADMIN', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "app-redirects" */ '@/views/Home/AppRedirects')
        },
        {
          path: 'app-redirects/create',
          name: 'app-redirects.create',
          meta: {
            roles: ['ADMIN', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "app-redirects.create" */ '@/views/Home/AppRedirects/create')
        },
        {
          path: 'app-redirects/:id/edit',
          name: 'app-redirects.edit',
          meta: {
            roles: ['ADMIN', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "app-redirects.edit" */ '@/views/Home/AppRedirects/edit')
        },
        {
          path: 'sportsbetting-polls',
          name: 'sportsbetting-polls',
          meta: {
            roles: ['ADMIN', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "sportsbetting-polls" */ '@/views/Home/SBPolls')
        },
        {
          path: 'sportsbetting-polls/create',
          name: 'sportsbetting-polls.create',
          meta: {
            roles: ['ADMIN', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "sportsbetting-polls.create" */ '@/views/Home/SBPolls/create')
        },
        {
          path: 'sportsbetting-polls/:id/edit',
          name: 'sportsbetting-polls.edit',
          meta: {
            roles: ['ADMIN', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "sportsbetting-polls.edit" */ '@/views/Home/SBPolls/edit')
        },
        {
          path: 'sportsbetting-polls/:id/results',
          name: 'sportsbetting-polls.results',
          meta: {
            roles: ['ADMIN', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "sportsbetting-polls.results" */ '@/views/Home/SBPolls/results')
        },
        {
          path: 'sportsbetting-categories',
          name: 'sportsbetting-categories',
          meta: {
            roles: ['ADMIN', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "sportsbetting-categories" */ '@/views/Home/SBCategories')
        },
        {
          path: 'sportsbetting-categories/create',
          name: 'sportsbetting-categories.create',
          meta: {
            roles: ['ADMIN', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "sportsbetting-categories.create" */ '@/views/Home/SBCategories/create')
        },
        {
          path: 'sportsbetting-categories/:id/edit',
          name: 'sportsbetting-categories.edit',
          meta: {
            roles: ['ADMIN', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "sportsbetting-categories.edit" */ '@/views/Home/SBCategories/edit')
        },
        {
          path: 'bestbooks-settings',
          name: 'bestbooks-settings',
          meta: {
            roles: ['ADMIN', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "bestbooks-settings" */ '@/views/Home/BestBooksSettings')
        },
        {
          path: 'bestbooks-settings/create',
          name: 'bestbooks-settings.create',
          meta: {
            roles: ['ADMIN', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "bestbooks-settings.create" */ '@/views/Home/BestBooksSettings/create')
        },
        {
          path: 'bestbooks-settings/:id/edit',
          name: 'bestbooks-settings.edit',
          meta: {
            roles: ['ADMIN', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "bestbooks-settings.edit" */ '@/views/Home/BestBooksSettings/edit')
        },
        {
          path: 'adhesive-banners',
          name: 'adhesive-banners',
          meta: {
            roles: ['ADMIN']
          },
          component: () =>
            import(/* webpackChunkName: "adhesive-banners" */ '@/views/Home/AdhesiveBanners')
        },
        {
          path: 'adhesive-banners/create',
          name: 'adhesive-banners.create',
          meta: {
            roles: ['ADMIN']
          },
          component: () =>
            import(/* webpackChunkName: "adhesive-banners.create" */ '@/views/Home/AdhesiveBanners/create')
        },
        {
          path: 'adhesive-banners/:id/edit',
          name: 'adhesive-banners.edit',
          meta: {
            roles: ['ADMIN']
          },
          component: () =>
            import(/* webpackChunkName: "adhesive-banners.edit" */ '@/views/Home/AdhesiveBanners/edit')
        },
        {
          path: 'in-article-promos',
          name: 'in-article-promos',
          meta: {
            roles: ['ADMIN', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "in-article-promos" */ '@/views/Home/InArticlePromos')
        },
        {
          path: 'in-article-promos/create',
          name: 'in-article-promos.create',
          meta: {
            roles: ['ADMIN', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "in-article-promos.create" */ '@/views/Home/InArticlePromos/create')
        },
        {
          path: 'in-article-promos/:id/edit',
          name: 'in-article-promos.edit',
          meta: {
            roles: ['ADMIN', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "in-article-promos.edit" */ '@/views/Home/InArticlePromos/edit')
        },
        {
          path: 'free-to-play',
          name: 'free-to-play',
          meta: {
            roles: ['ADMIN']
          },
          component: () =>
            import(/* webpackChunkName: "free-to-play" */ '@/views/Home/FreeToPlay')
        },
        {
          path: 'free-to-play-games',
          name: 'free-to-play-games',
          meta: {
            roles: ['ADMIN']
          },
          component: () =>
            import(/* webpackChunkName: "free-to-play-games" */ '@/views/Home/FreeToPlayGames')
        },
        {
          path: 'free-to-play-games/create',
          name: 'free-to-play-games.create',
          meta: {
            roles: ['ADMIN']
          },
          component: () =>
            import(/* webpackChunkName: "free-to-play-games.create" */ '@/views/Home/FreeToPlayGames/create')
        },
        {
          path: 'free-to-play-games/:id/edit',
          name: 'free-to-play-games.edit',
          meta: {
            roles: ['ADMIN']
          },
          component: () =>
            import(/* webpackChunkName: "free-to-play-games.edit" */ '@/views/Home/FreeToPlayGames/edit')

        },
        {
          path: 'podcast',
          name: 'podcast',
          meta: {
            roles: ['ADMIN']
          },
          component: () =>
            import(/* webpackChunkName: "podcast" */ '@/views/Home/Podcast')
        },
        {
          path: 'podcast-items',
          name: 'podcast-items',
          meta: {
            roles: ['ADMIN']
          },
          component: () =>
            import(/* webpackChunkName: "podcast-items" */ '@/views/Home/PodcastItems')
        },
        {
          path: 'podcast-items/create',
          name: 'podcast-items.create',
          meta: {
            roles: ['ADMIN']
          },
          component: () =>
            import(/* webpackChunkName: "podcast-items.create" */ '@/views/Home/PodcastItems/create')
        },
        {
          path: 'podcast-items/:id/edit',
          name: 'podcast-items.edit',
          meta: {
            roles: ['ADMIN']
          },
          component: () =>
            import(/* webpackChunkName: "podcast-items.edit" */ '@/views/Home/PodcastItems/edit')
        },
        {
          path: 'best-odds-page-settings',
          name: 'best-odds-page-settings',
          meta: {
            roles: ['ADMIN', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "best-odds-page-settings" */ '@/views/Home/BestOddsPageSettings')
        },
        {
          path: 'best-odds-page-settings/create',
          name: 'best-odds-page-settings.create',
          meta: {
            roles: ['ADMIN', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "best-odds-page-settings.create" */ '@/views/Home/BestOddsPageSettings/create')
        },
        {
          path: 'best-odds-page-settings/:id/edit',
          name: 'best-odds-page-settings.edit',
          meta: {
            roles: ['ADMIN', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "best-odds-page-settings.edit" */ '@/views/Home/BestOddsPageSettings/edit')
        },
        {
          path: 'futures-page-settings',
          name: 'futures-page-settings',
          meta: {
            roles: ['ADMIN', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "futures-page-settings" */ '@/views/Home/FuturesPageSettings')
        },
        {
          path: 'futures-page-settings/create',
          name: 'futures-page-settings.create',
          meta: {
            roles: ['ADMIN', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "futures-page-settings.create" */ '@/views/Home/FuturesPageSettings/create')
        },
        {
          path: 'futures-page-settings/:id/edit',
          name: 'futures-page-settings.edit',
          meta: {
            roles: ['ADMIN', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "futures-page-settings.edit" */ '@/views/Home/FuturesPageSettings/edit')
        },
        {
          path: 'landing-page-builder',
          name: 'landing-page-builder',
          meta: {
            roles: ['ADMIN', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "landing-page-builder" */ '@/views/Home/PageBuilder')
        },
        {
          path: 'landing-page-builder/create',
          name: 'landing-page-builder.create',
          meta: {
            roles: ['ADMIN', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "landing-page-builder.create" */ '@/views/Home/PageBuilder/create')
        },
        {
          path: 'landing-page-builder/:id/edit',
          name: 'landing-page-builder.edit',
          meta: {
            roles: ['ADMIN', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "landing-page-builder.edit" */ '@/views/Home/PageBuilder/edit')
        },
        {
          path: 'bestbooks-menu-settings',
          name: 'bestbooks-menu-settings',
          meta: {
            roles: ['ADMIN', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "bestbooks-menu-settings" */ '@/views/Home/BestBooksMenuSettings')
        },
        {
          path: 'in-content-banners',
          name: 'in-content-banners',
          meta: {
            roles: ['ADMIN', 'PUBLISHER']
          },
          component: () =>
            import(/* webpackChunkName: "in-content-banners" */ '@/views/Home/InContentConversionBanners')
        },
        {
          path: 'in-content-banners/create',
          name: 'in-content-banners.create',
          meta: {
            roles: ['ADMIN', 'PUBLISHER']
          },
          component: () =>
            import(/* webpackChunkName: "in-content-banners.create" */ '@/views/Home/InContentConversionBanners/create')
        },
        {
          path: 'in-content-banners/:id/edit',
          name: 'in-content-banners.edit',
          meta: {
            roles: ['ADMIN', 'PUBLISHER']
          },
          component: () =>
            import(/* webpackChunkName: "in-content-banners.edit" */ '@/views/Home/InContentConversionBanners/edit')
        },
        {
          path: 'authors',
          name: 'authors',
          meta: {
            roles: ['ADMIN', 'PUBLISHER']
          },
          component: () =>
            import(/* webpackChunkName: "authors" */ '@/views/Home/Authors')
        },
        {
          path: 'authors/create',
          name: 'authors.create',
          meta: {
            roles: ['ADMIN', 'PUBLISHER']
          },
          component: () =>
            import(/* webpackChunkName: "authors" */ '@/views/Home/Authors/create')
        },
        {
          path: 'authors/:id/edit',
          name: 'authors.edit',
          meta: {
            roles: ['ADMIN', 'PUBLISHER']
          },
          component: () =>
            import(/* webpackChunkName: "authors" */ '@/views/Home/Authors/edit')
        },
        {
          path: 'best-props-page-settings',
          name: 'best-props-page-settings',
          meta: {
            roles: ['ADMIN', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "best-props-page-settings" */ '@/views/Home/BestPropsPageSettings')
        },
        {
          path: 'best-props-page-settings/create',
          name: 'best-props-page-settings.create',
          meta: {
            roles: ['ADMIN', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "best-props-page-settings.create" */ '@/views/Home/BestPropsPageSettings/create')
        },
        {
          path: 'best-props-page-settings/:id/edit',
          name: 'best-props-page-settings.edit',
          meta: {
            roles: ['ADMIN', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "best-props-page-settings.edit" */ '@/views/Home/BestPropsPageSettings/edit')
        },
        {
          path: 'best-bets-page-settings',
          name: 'best-bets-page-settings',
          meta: {
            roles: ['ADMIN', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "best-bets-page-settings" */ '@/views/Home/BestBetsPageSettings')
        },
        {
          path: 'best-bets-page-settings/create',
          name: 'best-bets-page-settings.create',
          meta: {
            roles: ['ADMIN', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "best-bets-page-settings.create" */ '@/views/Home/BestBetsPageSettings/create')
        },
        {
          path: 'best-bets-page-settings/:id/edit',
          name: 'best-bets-page-settings.edit',
          meta: {
            roles: ['ADMIN', 'EDITOR']
          },
          component: () =>
            import(/* webpackChunkName: "best-bets-page-settings.edit" */ '@/views/Home/BestBetsPageSettings/edit')
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (store.state.auth.isAuthenticated && to.name !== 'auth.login') {
    if (to.meta.roles.includes(store.state.auth.token.user.role)) {
      next()
    } else {
      next({ name: 'articles' })
    }
  } else {
    next()
  }
})
export default router
